import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { PatternFormat as NumberFormat } from 'react-number-format';
import { deepEqual } from "../../../utils/object";

class Name extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            configuration: { ...props.meta },
            data: props.data ?? props.meta?.default,
            label: props.label,
            locked: Boolean(props.locked)
        }
    }

    
    getData = () => {
        return this.state.data;
    }
    
    
    onChange = (e) => {
        const newValue = e.target.value;
        if (newValue === this.state.data) return;
        
        this.setState({
            data: newValue
        }, () => {
            if (this.props.onChange) {
                this.props.onChange();
            }
        });
    }

    componentDidUpdate(oldProps) {
        // Update state when props.data changes
        if (oldProps.data === this.props.data) return;
        const newData = this.props.data ?? this.props.meta?.default;
        if (deepEqual(this.state.data, newData)) return;
        
        // Just sync local state – no callback, no props.onChange here
        this.setState({
            data: newData
        });
    }

    render() {
        return (<>
            {this.state.label ?
                <Row className="g-3">
                    <Col lg="12">
                        <h2 className="small-title">{this.state.label}</h2>
                    </Col>
                </Row>
                : ``}
            <Row className="g-3">
                <Col lg="12">
                    <div className="mb-3 top-label">
                        {(this.state.locked) ?
                            <Form.Control type="text" name={this.props.element} value={this.state.data || ""} readOnly={true} style={{ width: this.state.configuration.width }} />
                            :
                            <NumberFormat format={this.state.configuration.format} mask={this.state.configuration.mask} className="form-control" value={this.state.data} allowEmptyFormatting={this.state.configuration.allowEmptyFormatting} onChange={this.onChange} name={this.props.element} />
                        }
                        <Form.Label>{this.state.configuration.caption}</Form.Label>
                    </div>
                </Col>
            </Row>
        </>)
    }
}

export default Name;